import { render, staticRenderFns } from "./NavbarSocialsDropdown.vue?vue&type=template&id=1ad63823&scoped=true&"
import script from "./NavbarSocialsDropdown.vue?vue&type=script&lang=js&"
export * from "./NavbarSocialsDropdown.vue?vue&type=script&lang=js&"
import style0 from "./NavbarSocialsDropdown.vue?vue&type=style&index=0&id=1ad63823&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad63823",
  null
  
)

export default component.exports